<template>
  <sidebar-item
    v-if="!isAlmacenero"
    :link="{
      name: 'Menú Diario',
      icon: 'ni ni-calendar-grid-58 text-primary'
    }"
  >
    <sidebar-item
      v-if="!isAlmacenero"
      :link="{
        name: 'Niveles',
        icon: 'ni ni-diamond text-primary',
        path: '/niveles'
      }"
    ></sidebar-item>
    <sidebar-item
      v-if="!isAlmacenero"
      :link="{
        name: 'Pedidos',
        icon: 'ni ni-bag-17 text-primary',
        path: '/pedidos'
      }"
    ></sidebar-item>
    <sidebar-item
      v-if="hasDarkKitchen && !isAlmacenero"
      :link="{
        name: 'Supervisor',
        icon: 'ni ni-single-02 text-green'
      }"
    >
      <sidebar-item
        :link="{
          name: 'Checklist',
          path: '/supervisor/checklist',
          icon: 'ni ni-single-02 text-primary'
        }"
      />
    </sidebar-item>
    <sidebar-item
      v-if="!isAlmacenero"
      :link="{
        name: 'Pesos Cocidos',
        icon: 'ni ni-ruler-pencil text-success',
        path: '/pesos-cocidos'
      }"
    ></sidebar-item>
    <sidebar-item
      v-if="!isAlmacenero"
      :link="{
        name: 'Cantidades',
        icon: 'ni ni-bullet-list-67 text-primary',
        path: '/cantidades'
      }"
    ></sidebar-item>
    <sidebar-item
      v-if="!isAlmacenero"
      :link="{
        name: 'Recetas',
        icon: 'ni ni-collection text-primary',
        path: '/recetas'
      }"
    ></sidebar-item>
    <sidebar-item
      v-if="!isAlmacenero"
      :link="{
        name: 'Reclamos',
        icon: 'ni ni-book-bookmark text-primary',
        path: '/reclamos'
      }"
    ></sidebar-item>
    <sidebar-item
      v-if="!isAlmacenero"
      :link="{
        name: 'Feedback',
        icon: 'ni ni-single-02 text-primary',
        path: '/feedback'
      }"
    ></sidebar-item>
    <sidebar-item
      v-if="!isAlmacenero"
      :link="{
        name: 'Rutas',
        icon: 'ni ni-watch-time text-primary',
        path: '/rutas'
      }"
    ></sidebar-item>
    <sidebar-item
      v-if="!isAlmacenero"
      :link="{
        name: 'Entregas',
        icon: 'ni ni-delivery-fast text-warning',
        path: '/delivery'
      }"
    ></sidebar-item>
  </sidebar-item>
</template>

<script>
export default {
  name: 'DailyMenuSection',
  computed: {
    hasDarkKitchen() {
      return this.$store.getters.getKitchenId !== null;
    },
    isAlmacenero() {
      return this.$store.getters.getUserRol === 'ALMACENERO';
    }
  }
};
</script>
